import axios from 'axios';

//const instance = axios.create();
const prodConfig = {
    baseURL: process.env.REACT_APP_PROD_SERVICEURL
};
const devConfig = {
    baseURL: process.env.REACT_APP_DEV_SERVICEURL
};
const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

const instance = axios.create(config);

export default instance;
